/**
 * Конвертация форматов чисел из numbro (используется Handsontable) в Excel.
 *
 * numbro:   '0,0'        '0,0.00'      '0.00%'    '0,0.00 ₽'
 * Excel:    '#,##0'      '#,##0.00'    '0.00%'    '#,##0.00 ₽'
 *
 * Алгоритм минималистичный: 'thousand-grouping zero pair' (`0,0`) превращается
 * в Excel-эквивалент `#,##0`. Остальные части (десятичные нули, проценты,
 * литералы валюты) в обоих языках формата записываются одинаково.
 */
export function numbroToExcelFormat(pattern: unknown): string | undefined {
  if (typeof pattern !== 'string' || !pattern) return undefined;
  return pattern.replace(/0,0/g, '#,##0');
}
